import React from 'react';
import './InfoPage.css';

function Covid() {
  return (
    <div className="info-page">
      <div className="info-container">
        <h1>Resposta COVID-19</h1>

        <section className="info-section">
          <h2>Nosso Compromisso com Sua Saúde e Segurança</h2>
          <p>Na Nukki, a saúde e segurança de nossa comunidade é nossa maior prioridade. Implementamos protocolos aprimorados de limpeza e políticas flexíveis para ajudá-lo a viajar com confiança.</p>
        </section>

        <section className="info-section">
          <h3>Protocolo de Limpeza Aprimorada</h3>
          <p>Fizemos parceria com especialistas em saúde e hospitalidade para desenvolver um protocolo abrangente de limpeza para anfitriões.</p>

          <div className="covid-feature">
            <h4>Processo de Limpeza Aprimorada em 5 Etapas</h4>
            <ol>
              <li><strong>Preparar:</strong> Use equipamento de proteção adequado, incluindo máscaras e luvas</li>
              <li><strong>Limpar:</strong> Limpe completamente todas as superfícies com sabão e água</li>
              <li><strong>Sanitizar:</strong> Use desinfetantes aprovados em superfícies de alto contato</li>
              <li><strong>Verificar:</strong> Certifique-se de que todos os cômodos e áreas foram adequadamente limpos</li>
              <li><strong>Ventilar:</strong> Arejar os espaços antes da chegada do hóspede</li>
            </ol>
          </div>

          <div className="covid-feature">
            <h4>Foco em Superfícies de Alto Contato</h4>
            <p>Atenção especial para:</p>
            <ul>
              <li>Maçanetas e interruptores de luz</li>
              <li>Controles remotos e eletrônicos</li>
              <li>Eletrodomésticos e bancadas de cozinha</li>
              <li>Acessórios de banheiro</li>
              <li>Corrimões e barras de apoio</li>
            </ul>
          </div>
        </section>

        <section className="info-section">
          <h3>Política de Cancelamento Flexível</h3>
          <p>Entendemos que planos de viagem podem precisar mudar. Nossa política de circunstâncias atenuantes cobre:</p>
          <ul>
            <li>Doença ou exposição relacionada à COVID-19</li>
            <li>Restrições de viagem impostas pelo governo</li>
            <li>Requisitos de quarentena</li>
          </ul>
          <p>Hóspedes afetados por essas circunstâncias podem ser elegíveis para reembolso total ou crédito. Documentação pode ser necessária.</p>
        </section>

        <section className="info-section">
          <h3>Diretrizes de Segurança para Hóspedes</h3>
          <ul>
            <li>Siga as diretrizes e regulamentos de saúde locais</li>
            <li>Pratique distanciamento social ao interagir com anfitriões ou outros</li>
            <li>Use máscara em espaços compartilhados quando necessário</li>
            <li>Lave as mãos frequentemente e use o sanitizante fornecido</li>
            <li>Comunique-se com seu anfitrião sobre quaisquer preocupações de saúde</li>
            <li>Fique em casa se estiver se sentindo mal</li>
          </ul>
        </section>

        <section className="info-section">
          <h3>Suporte para Anfitriões</h3>
          <p>Fornecemos recursos para ajudar os anfitriões a manter altos padrões de segurança:</p>
          <ul>
            <li>Acesso à educação sobre protocolo de limpeza</li>
            <li>Diretrizes para check-in/check-out sem contato</li>
            <li>Tempo recomendado entre estadias de hóspedes para limpeza adequada</li>
            <li>Informações sobre produtos de limpeza aprovados</li>
            <li>Suporte para implementar medidas de segurança</li>
          </ul>
        </section>

        <section className="info-section">
          <h3>Opções Sem Contato</h3>
          <p>Muitas propriedades agora oferecem recursos sem contato:</p>
          <ul>
            <li>Auto check-in com teclado ou caixa de chaves</li>
            <li>Guias digitais e manuais da casa</li>
            <li>Comunicação remota com anfitriões</li>
            <li>Opções de pagamento móvel</li>
          </ul>
        </section>

        <section className="info-section">
          <h3>Mantenha-se Informado</h3>
          <p>Orientações e restrições de viagem continuam a evoluir. Recomendamos:</p>
          <ul>
            <li>Verificar as diretrizes locais de COVID-19 antes de viajar</li>
            <li>Revisar os requisitos de entrada do seu destino</li>
            <li>Entender as políticas específicas da sua acomodação</li>
            <li>Manter informações de contato de emergência à mão</li>
          </ul>
        </section>

        <section className="info-section">
          <h3>Perguntas ou Preocupações?</h3>
          <p>Nossa equipe de suporte está aqui para ajudar com quaisquer perguntas ou preocupações relacionadas à COVID-19 sobre sua estadia.</p>
        </section>
      </div>
    </div>
  );
}

export default Covid;
